import { render, staticRenderFns } from "./OtpVerify.vue?vue&type=template&id=75d50658&scoped=true"
import script from "./OtpVerify.vue?vue&type=script&lang=js"
export * from "./OtpVerify.vue?vue&type=script&lang=js"
import style0 from "./OtpVerify.vue?vue&type=style&index=0&id=75d50658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d50658",
  null
  
)

export default component.exports